// Merkezi ürün veri kaynağı
export const categories = [
  { id: 'bimetal', label: 'Bimetal Şerit Testereler', path: '/bimetal-serit-testere' },
  { id: 'karbur', label: 'Karbür Şerit Testereler', path: '/karbur-serit-testere' },
  { id: 'elmas-cbn', label: 'Elmas ve CBN Şerit Testereler', path: '/elmas-cbn-testere' },
  { id: 'karbon', label: 'Karbon Şerit Testereler', path: '/karbon-serit-testere' },
  { id: 'daire-testere', label: 'Daire Testereler', path: '/daire-testere' },
];

export const products = {
  bimetal: {
    title: 'Bimetal Şerit Testere Bıçakları',
    subtitle: 'Genel çelik ve profil kesimleri için en ekonomik ve uzun ömürlü çözüm.',
    seoContent: `
      <h2>Endüstriyel Bimetal Şerit Testere Çözümleri</h2>
      <p>Bimetal şerit testere bıçakları, modern metal işleme endüstrisinin en çok tercih edilen ve maliyet-performans oranı en yüksek kesici takımlarıdır. İki farklı metalin (genellikle yay çeliğinden esnek bir sırt ve yüksek hız çeliğinden (HSS) dişler) elektron ışını kaynağı ile birleştirilmesiyle üretilen bu bıçaklar, hem esneklik hem de üstün kesim sertliğini bir arada sunar.</p>
      
      <h3>Neden Bimetal Testere Seçmelisiniz?</h3>
      <p>Atölyenizde veya fabrikanızda karbon çeliği, yapı çelikleri, düşük alaşımlı çelikler ve orta sertlikteki döküm malzemeleri kesiyorsanız, Bimetal M42 veya M51 serileri sizin için en doğru seçimdir. Diş uçlarındaki %8-10 kobalt içeriği, ısıl direncini artırarak bıçağın keskinliğini uzun süre korumasını sağlar.</p>
      
      <h3>Kullanım Alanları ve Avantajları</h3>
      <ul>
        <li><strong>Genel Yapı Çelikleri:</strong> Kare, yuvarlak ve lama formundaki standart çeliklerin kesiminde yüksek hız sunar.</li>
        <li><strong>Profil ve Boru Kesimi:</strong> Değişken adımlı (Variable Pitch) diş yapısı sayesinde titreşimi en aza indirerek pürüzsüz yüzey sağlar.</li>
        <li><strong>Yüksek Yorulma Mukavemeti:</strong> Esnek sırt yapısı, testerenin kasnaklar etrafında sürekli dönmesiyle oluşan metal yorgunluğuna karşı dirençlidir, çatlama riskini azaltır.</li>
      </ul>
      <p>NetTest Testere olarak sunduğumuz bimetal serisi ile üretim hatlarınızda kesim başına maliyeti optimize ederken, Alman mühendisliğinin sunduğu pürüzsüz yüzey kalitesinden taviz vermezsiniz.</p>
    `,
    groups: [
      {
        label: 'M42 Kesme Malzemeli',
        items: [
          {
            id: 'marathon-m42', name: 'MARATHON® M42', level: 2, tagline: 'Küçük ve büyük kesitler için çok amaçlı ürün',
            desc: 'MARATHON® M42, ekonomik şerit testere bıçağının özüdür ve sürekli yüksek kalite ile geniş bir uygulama yelpazesini temsil eder. Testere bandının süper finişi ve keskin kesme kenarları kesme yüzeyi kalitesini iyileştirir.',
            specs: [
              { label: 'Ürün Seviyesi', value: '2' },
              { label: 'Diş Tipi', value: 'Pençe dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 80 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Sertlik (HRC)', value: '65–67 HRC' },
              { label: 'Uygulama', value: 'Genel amaçlı, katı & içi boş' },
            ],
            advantages: ['Geniş uygulama yelpazesi', 'Süper finish bant yüzeyi', 'Makine bant kılavuzlarını korur', 'Yüksek yorulma mukavemeti'],
          },
          {
            id: 'marathon-sw-m42', name: 'MARATHON® SW M42', level: 2, tagline: 'Dar şerit optimizeli versiyon',
            desc: 'Küçük kesitler ve dar şerit uygulamaları için geliştirilmiş MARATHON serisi. Küçük çaplı boru ve profillerden oluşan kesimler için uygundur.',
            specs: [
              { label: 'Ürün Seviyesi', value: '2' },
              { label: 'Diş Tipi', value: 'Pençe dişli (SW)' },
              { label: 'Malzeme', value: 'Katı madde / İçi boş' },
              { label: 'Bant Genişliği', value: '6 × 0,50 – 20 × 0,90 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Uygulama', value: 'Küçük kesit, ince boru & profil' },
            ],
            advantages: ['Dar şerit optimize', 'İnce et kalınlıklı malzeme', 'Düşük vibrasyon'],
          },
          {
            id: 'proflex-m42', name: 'PROFLEX® M42', level: 3, tagline: 'Profil ve boru kesiminde esneklik',
            desc: 'İçi boş profil ve ince cidarlı boru kesiminde değişken adımlı diş geometrisiyle titreşim azaltma ve üstün hassasiyet.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Değişken adımlı (VA)' },
              { label: 'Malzeme', value: 'İçi boş profil / Boru' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 67 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Uygulama', value: 'Boru, profil, karma kesit' },
            ],
            advantages: ['Değişken adım sayesinde düşük vibrasyon', 'Pürüzsüz kesme yüzeyi', 'Uzun bıçak ömrü'],
          },
          {
            id: 'proflex-sw-m42', name: 'PROFLEX® SW M42', level: 3, tagline: 'Dar profil için değişken adım',
            desc: 'Küçük kesitli profiller için geliştirilen dar bant versiyonu. Değişken adımlı diş sayesinde titreşim ve gürültü minimuma iner.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Değişken adımlı (VA) SW' },
              { label: 'Malzeme', value: 'İnce cidarlı boru / Küçük profil' },
              { label: 'Bant Genişliği', value: '6 × 0,50 – 13 × 0,65 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Uygulama', value: 'Küçük çaplı boru, dar profil' },
            ],
            advantages: ['Dar şerit + değişken adım kombinasyonu', 'İnce et kalınlığı için ideal', 'Minimum vibrasyon'],
          },
          {
            id: 'skalar-m42', name: 'SKALAR® M42', level: 3, tagline: 'Büyük kesit kütük kesiminde güç',
            desc: 'Büyük kütük, ingot ve katı malzeme kesimlerinde üstün dayanımlılık ve uzun ömür için geliştirilmiştir.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Pençe dişli' },
              { label: 'Malzeme', value: 'Katı madde / Büyük kütük' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Uygulama', value: 'Büyük kesit katı malzeme, ingot' },
            ],
            advantages: ['Büyük kesitlerde güvenilir', 'Uzun bıçak ömrü', 'Düşük maliyetli büyük kesit çözümü'],
          },
          {
            id: 'selekta-gs-m42', name: 'SELEKTA® GS M42', level: 3, tagline: 'Karma malzeme için dengeli performans',
            desc: 'Karma malzeme gruplarında, değişken kesit boyutlarında dengeli ve güvenilir kesim performansı sunar.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Değişken adımlı (GS)' },
              { label: 'Malzeme', value: 'Karma / Çoklu kesit' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 67 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Uygulama', value: 'Karma malzeme, değişken kesit' },
            ],
            advantages: ['Çok yönlü kullanım', 'GS geometrisi ile düşük gürültü', 'Çeşitli çelik türleri'],
          },
          {
            id: 'primar-m42', name: 'PRIMAR® M42', level: 1, tagline: 'Ekonomik genel amaçlı seçenek',
            desc: 'Genel yapısal çelik kesiminde ekonomik fiyat-performans çözümü. Standart bimetal kesim için giriş seviyesi model.',
            specs: [
              { label: 'Ürün Seviyesi', value: '1' },
              { label: 'Diş Tipi', value: 'Pençe dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 54 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 (8% Co)' },
              { label: 'Uygulama', value: 'Genel yapısal çelik' },
            ],
            advantages: ['Ekonomik fiyat', 'Standart çelik için uygun', 'Kolay temin'],
          },
        ]
      },
      {
        label: 'M42 + Sert Malzeme Kaplamalı — PREMIUM',
        items: [
          {
            id: 'proflex-premium-m42', name: 'PROFLEX® PREMIUM M42', level: 4, tagline: 'Profile özel premium kaplama',
            desc: 'Sert malzeme kaplaması + değişken adımlı diş geometrisi kombinasyonuyla profil kesiminde maksimum ömür ve verimlilik.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Değişken adımlı (VA)' },
              { label: 'Malzeme', value: 'İçi boş profil / Boru' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 67 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 + Sert Kaplama' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
            ],
            advantages: ['%30 daha uzun bıçak ömrü', 'Premium kaplama kalitesi', 'Yüksek verimli profil kesimi'],
          },
          {
            id: 'proflex-premium-sw-m42', name: 'PROFLEX® PREMIUM SW M42', level: 4, tagline: 'Dar premium profil çözümü',
            desc: 'Dar bantta premium kaplama. Küçük profil ve boru kesimlerinde en uzun bıçak ömrü.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Değişken adımlı SW' },
              { label: 'Malzeme', value: 'Küçük profil / İnce boru' },
              { label: 'Bant Genişliği', value: '6 × 0,50 – 13 × 0,65 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 + Sert Kaplama' },
            ],
            advantages: ['Dar bant premium kalite', 'Uzun ömür', 'Düşük maliyet/kesim oranı'],
          },
          {
            id: 'skalar-premium-m42', name: 'SKALAR® PREMIUM M42', level: 4, tagline: 'Büyük kesit için premium',
            desc: 'Büyük kütük kesiminde premium sert kaplama sayesinde maksimum bıçak ömrü ve maliyet avantajı.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Pençe dişli' },
              { label: 'Malzeme', value: 'Büyük kesit katı malzeme' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 + Sert Kaplama' },
            ],
            advantages: ['Büyük kesit premium', 'En uzun ömür', 'Maliyet etkin'],
          },
          {
            id: 'selekta-gs-premium-m42', name: 'SELEKTA® GS PREMIUM M42', level: 4, tagline: 'Karma malzeme premium',
            desc: 'Çok yönlü kullanım için sert kaplamalı versiyon. Farklı malzeme gruplarında premium performans.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Değişken adımlı (GS)' },
              { label: 'Malzeme', value: 'Karma / Çoklu kesit' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 67 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M42 + Sert Kaplama' },
            ],
            advantages: ['Çok yönlü premium', 'GS + kaplama kombinasyonu', 'Yüksek verimlilik'],
          },
        ]
      },
      {
        label: 'M51 Kesme Malzemeli',
        items: [
          {
            id: 'marathon-m51', name: 'MARATHON® M51', level: 4, tagline: 'Yeni nesil kesme malzemesi',
            desc: 'Yeni nesil M51 kesme malzemesiyle standart M42\'ye kıyasla çok daha yüksek sertlik ve dayanım. Gelecek nesil bimetal teknolojisi.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Pençe dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M51 (Yeni Nesil)' },
              { label: 'Sertlik (HRC)', value: '67–69 HRC' },
            ],
            advantages: ['M51 ile üstün sertlik', 'Daha yüksek kesim hızı', 'Uzun bıçak ömrü'],
          },
          {
            id: 'skalar-m51', name: 'SKALAR® M51', level: 4, tagline: 'Büyük kesit M51 gücü',
            desc: 'Büyük kütük kesimlerinde M51 teknolojisi ile maksimum üretkenlik ve bıçak ömrü.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Pençe dişli' },
              { label: 'Malzeme', value: 'Büyük kesit katı malzeme' },
              { label: 'Bant Genişliği', value: '34 × 1,10 – 80 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M51 (Yeni Nesil)' },
            ],
            advantages: ['Büyük kesit için optimize', 'M51 teknolojisi', 'Maksimum üretkenlik'],
          },
          {
            id: 'selekta-gs-m51', name: 'SELEKTA® GS M51', level: 4, tagline: 'Karma malzeme M51',
            desc: 'Farklı malzeme gruplarında M51 teknolojisi ile değişken adımlı diş geometrisinin kombinasyonu.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Değişken adımlı (GS)' },
              { label: 'Malzeme', value: 'Karma / Çoklu kesit' },
              { label: 'Bant Genişliği', value: '20 × 0,90 – 67 × 1,60 mm' },
              { label: 'Kesme Malzemesi', value: 'M51 (Yeni Nesil)' },
            ],
            advantages: ['GS + M51 sinerjisi', 'Karma malzeme için mükemmel', 'Yüksek üretkenlik'],
          },
        ]
      },
      {
        label: 'Starrett Bimetal Serisi',
        items: [
          {
            id: 'intenss-pro', name: 'INTENSS™ PRO', level: 3, tagline: 'Yüksek Performanslı Kesim',
            desc: 'Ağır hizmet kesim uygulamaları için geliştirilmiş olan Intenss PRO serisi, değişken adımlı diş yapısıyla vibrasyonu en aza indirerek takım tezgahı bileşenlerinde daha uzun ömür sunar.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Malzeme', value: 'Katı Madde / Yapısal Çelik' },
              { label: 'Kesme Malzemesi', value: 'Bimetal M42' },
            ],
            advantages: ['Yüksek üretim verimliliği', 'Düşük vibrasyon', 'Uzun bıçak ömrü'],
          },
          {
            id: 'univerz', name: 'UNIVERZ™', level: 2, tagline: 'Genel Amaçlı Kesim',
            desc: 'Geniş bir uygulama yelpazesi için mükemmel fiyat/performans dengesi sağlayan, atölye ve imalatçılara yönelik dayanıklı standart şerit.',
            specs: [
              { label: 'Ürün Seviyesi', value: '2' },
              { label: 'Malzeme', value: 'Karma / Genel Amaçlı' },
              { label: 'Kesme Malzemesi', value: 'Bimetal M42' },
            ],
            advantages: ['Çok yönlü kullanım', 'Ekonomik maliyet', 'Esnek yapı'],
          },
          {
            id: 'intenss-pro-die', name: 'INTENSS™ PRO-DIE', level: 3, tagline: 'Kalıp Çeliği Kesimi',
            desc: 'Alet ve kalıp çelikleri ile alaşımlı çeliklerin kesiminde kullanılmak üzere, kalıpçı (die) ve takım tezgahları için özel diş yapısıyla tasarlanmıştır.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Malzeme', value: 'Kalıp / Takım Çelikleri' },
              { label: 'Kesme Malzemesi', value: 'Bimetal M42' },
            ],
            advantages: ['Hassas yüzey kalitesi', 'Kalıp kesimi için ideal'],
          },
          {
            id: 'intenss-pro-vth', name: 'INTENSS™ PRO-VTH', level: 3, tagline: 'Sürekli Üretim Kesimi',
            desc: 'Sürekli üretim bandında, değişken kesitli profil ve masif malzeme kesiminde yüksek dayanım gösteren VTH diş profilli sürüm.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Malzeme', value: 'Sürekli Üretim' },
            ],
            advantages: ['Yüksek dayanım', 'Uzun bıçak ömrü'],
          },
          {
            id: 'primalloy', name: 'PRIMALLOY™', level: 4, tagline: 'Zorlu Alaşım Uzmanı',
            desc: 'Titanyum, paslanmaz çelik, Inconel® ve egzotik alaşımlar gibi son derece rijit metallerin kesimi için üstün aşınma direnci sağlayan premium bimetal.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Malzeme', value: 'Sert Alaşımlar / Paslanmaz' },
              { label: 'Kesme Malzemesi', value: 'Bimetal M51' },
            ],
            advantages: ['Egzotik alaşımlar için ideal', 'Termal şok direnci'],
          },
          {
            id: 'tennax-pro', name: 'TENNAX™ PRO', level: 4, tagline: 'Ultra Yüksek Performans',
            desc: 'Büyük çaplı tüp ve profilleri yapısal uygulamalarda kesmek için tasarlanmış yüksek hızlı, geniş aralıklı profesyonel seri testere bıçağı.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Malzeme', value: 'Tüp / Profil Çelikler' },
            ],
            advantages: ['Yüksek hız', 'Isınmaya karşı dayanıklı'],
          },
        ]
      },
    ]
  },

  karbur: {
    title: 'Karbür Uçlu Şerit Testereler',
    subtitle: 'Paslanmaz ve sert alaşımlarda maksimum kesim hızı ve dayanıklılık.',
    seoContent: `
      <h2>Karbür Uçlu (TCT) Şerit Testere Teknolojisi</h2>
      <p>Karbür uçlu şerit testereler (TCT - Tungsten Carbide Tipped), metal kesim dünyasında "Formula 1" seviyesindeki performansı temsil eder. Geleneksel bimetal bıçakların sınırlarını zorladığı veya kesmekte yetersiz kaldığı en sert ve en aşındırıcı malzemeler için özel olarak geliştirilmiştir.</p>
      
      <h3>Neden Karbür Testere Tercih Edilmelidir?</h3>
      <p>Paslanmaz çelikler (304, 316L, Dubleks), Takım çelikleri, Havacılık ve Savunma sanayinde kullanılan süper alaşımlar (Inconel, Titanyum, Hastelloy) gibi malzemeler kesim sırasında aşırı ısı üretir. Karbür uçlar, bu yüksek ısılarda dahi sertliğini koruyarak kesim hızını bimetal bıçaklara göre 2-3 kat artırabilir.</p>
      
      <h3>Öne Çıkan Kullanım Senaryoları</h3>
      <ul>
        <li><strong>Zorlu Alaşımlar:</strong> Nikel ve kobalt bazlı yüksek sıcaklık alaşımlarında pürüzsüz ve hızlı kesim.</li>
        <li><strong>Hassas Yüzey Kalitesi:</strong> Karbür uçların keskinliği, kesilen parçada taşlama ihtiyacını azaltacak kadar temiz yüzeyler bırakır.</li>
        <li><strong>Maksimum Verimlilik:</strong> Seri üretim hatlarında kesim sürelerini kısaltarak toplam üretim maliyetlerini aşağı çeker.</li>
      </ul>
      <p>FUTURA® ve DUROSET® gibi dünya standartlarındaki modellerimizle, en zorlu metal kesim operasyonlarınızda teknik partneriniz olmaya hazırız.</p>
    `,
    groups: [
      {
        label: 'Standart Karbür Uçlu',
        items: [
          {
            id: 'duroset', name: 'DUROSET®', level: 2, tagline: 'Sağlam ve çok yönlü set tasarım',
            desc: 'Set tasarımlı DUROSET® karbür şerit testere bıçağı, hem eski bimetal makinelerde hem de modern karbür makinelerde çalışır. Bimetal bıçaklara kıyasla %50\'ye varan performans artışı sağlar.',
            specs: [
              { label: 'Ürün Seviyesi', value: '2' },
              { label: 'Diş Tipi', value: 'Karbür Set dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Standart' },
              { label: 'Uygulama', value: 'Yapısal, sementasyon, temperleme çelikleri' },
            ],
            advantages: ['%50\'ye varan performans artışı', 'Eski makinelerle uyumlu', 'Set tasarım dayanıklılığı'],
          },
          {
            id: 'futura', name: 'FUTURA®', level: 3, tagline: 'En çok satan karbür testere',
            desc: 'Karbür için uygun modern şerit testere makinelerinde FUTURA®, yapısal, sertleştirilmiş ve karbon çeliklerinde çoklu kesimler için idealdir.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Standart' },
              { label: 'Uygulama', value: 'Yapısal, karbon, temperleme çelikleri' },
            ],
            advantages: ['Mükemmel standartlar', 'Güvenilir üretim', 'Geniş çelik yelpazesi'],
          },
          {
            id: 'taurus', name: 'TAURUS®', level: 3, tagline: 'Büyük kesit karbür gücü',
            desc: 'Büyük kesitli ve çoklu malzeme kesimlerinde güçlü karbür uçlu dayanım.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli' },
              { label: 'Malzeme', value: 'Büyük kesit / Çoklu kesim' },
              { label: 'Bant Genişliği', value: '34 × 1,10 – 80 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Ağır koşul' },
              { label: 'Uygulama', value: 'Büyük kütük, karışık kesit' },
            ],
            advantages: ['Büyük kesit için optimize', 'Çoklu kesim operasyonu', 'Güçlü karbür uç'],
          },
          {
            id: 'futura-va', name: 'FUTURA® VA', level: 3, tagline: 'Titreşim azaltma teknolojisi',
            desc: 'Değişken adımlı diş geometrisiyle titreşim and gürültü minimize edilmiştir. İçi boş profil ve boru kesimlerinde mükemmel.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Karbür, Değişken adımlı (VA)' },
              { label: 'Malzeme', value: 'İçi boş profil / Boru' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Standart' },
              { label: 'Uygulama', value: 'Profil, boru, karma kesit' },
            ],
            advantages: ['Minimum vibrasyon', 'Düşük gürültü', 'Profil kesimde optimal'],
          },
          {
            id: 'futura-718', name: 'FUTURA® 718', level: 4, tagline: 'Inconel 718 özel tasarım',
            desc: 'Inconel 718 ve benzer nikel bazlı süper alaşımlarda maksimum performans için özel grade karbür uçlarla geliştirilmiştir.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Özel' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli' },
              { label: 'Malzeme', value: 'Süper alaşım / Nikel bazlı' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 67 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Özel Inconel grade' },
              { label: 'Uygulama', value: 'Inconel 718, Nikel, Kobalt alaşımları' },
            ],
            advantages: ['Inconel 718 için özel tasarım', 'Özel karbür grade', 'Yüksek sıcaklık dayanımı'],
          },
          {
            id: 'ecodur', name: 'ECODUR®', level: 1, tagline: 'Ekonomik karbür çözümü',
            desc: 'Standart çelik kesiminde bimetal performansının üzerinde, ekonomik bir karbür uçlu seçenek.',
            specs: [
              { label: 'Ürün Seviyesi', value: '1' },
              { label: 'Diş Tipi', value: 'Karbür Set dişli' },
              { label: 'Malzeme', value: 'Katı madde / Yapısal çelik' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 67 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Ekonomi grade' },
              { label: 'Uygulama', value: 'Genel yapısal çelik' },
            ],
            advantages: ['Ekonomik karbür giriş noktası', 'Bimetal üstü performans', 'Maliyet etkin'],
          },
          {
            id: 'futura-sn', name: 'FUTURA® SN', level: 3, tagline: 'Paslanmaz çelik optimizeli',
            desc: 'Paslanmaz çelik, dubleks ve özel alaşımlar için optimize edilmiş karbür grade ve diş geometrisi.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli (SN)' },
              { label: 'Malzeme', value: 'Paslanmaz çelik / Dubleks' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 67 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'SN — Paslanmaz Özel' },
              { label: 'Uygulama', value: 'Paslanmaz, dubleks, süper alaşım' },
            ],
            advantages: ['Paslanmaz için optimize', 'Özel SN karbür grade', 'Pürüzsüz yüzey kalitesi'],
          },
          {
            id: 'tct', name: 'TCT®', level: 2, tagline: 'Genel amaçlı karbür seri',
            desc: 'Geniş uygulama yelpazesine sahip genel amaçlı karbür uçlu testere serisi.',
            specs: [
              { label: 'Ürün Seviyesi', value: '2' },
              { label: 'Diş Tipi', value: 'Karbür Set dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 67 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Standart' },
              { label: 'Uygulama', value: 'Yapısal çelik, sementasyon' },
            ],
            advantages: ['Geniş uygulama', 'Güvenilir performans', 'Standart çelikler'],
          },
          {
            id: 'tctyre', name: 'TCTYRE®', level: 2, tagline: 'Teker ve halka profil kesimi',
            desc: 'Teker, halka ve dairesel profillerin kesiminde özelleştirilmiş karbür uçlu tasarım.',
            specs: [
              { label: 'Ürün Seviyesi', value: '2' },
              { label: 'Diş Tipi', value: 'Karbür Özel dişli' },
              { label: 'Malzeme', value: 'Teker / Halka / Dairesel profil' },
              { label: 'Bant Genişliği', value: '34 × 1,10 – 67 × 1,60 mm' },
              { label: 'Karbür Grade', value: 'Teker optimize' },
              { label: 'Uygulama', value: 'Teker, halka, dairesel kesit' },
            ],
            advantages: ['Teker kesimi için özel', 'Halka profil optimize', 'Uzun ömürlü karbür'],
          },
        ]
      },
      {
        label: 'Sert Malzeme Kaplamalı — PREMIUM',
        items: [
          {
            id: 'duroset-premium', name: 'DUROSET® PREMIUM', level: 4, tagline: 'Set tasarım + premium kaplama',
            desc: 'Set tasarımlı karbür uçla sert malzeme kaplamanın kombinasyonu. Maksimum bıçak ömrü ve üretkenlik.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Karbür Set dişli' },
              { label: 'Malzeme', value: 'Katı madde' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
              { label: 'Uygulama', value: 'Yapısal çelik, yüksek verimlilik' },
            ],
            advantages: ['En uzun ömür', 'Premium kaplama', 'Düşük maliyet/kesim'],
          },
          {
            id: 'futura-premium', name: 'FUTURA® PREMIUM', level: 4, tagline: 'Karbür premium flag model',
            desc: 'FUTURA® serisinin premium kaplamalı versiyonu. Nikel bazlı alaşımlar başta olmak üzere tüm zorlayıcı malzemelerde yüksek verim.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli' },
              { label: 'Malzeme', value: 'Inconel, Titanyum, Nikel alaşımı' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 80 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
              { label: 'Uygulama', value: 'Süper alaşım, zorlayıcı malzeme' },
            ],
            advantages: ['Süper alaşım kesimi', 'Premium kaplama', 'Maksimum verimlilik'],
          },
          {
            id: 'profidur', name: 'PROFIDUR®', level: 4, tagline: 'Ağır koşul premium karbür',
            desc: 'Ağır kesim koşulları için sert kaplama teknolojisi ile güçlendirilmiş yüksek performanslı karbür model.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli' },
              { label: 'Malzeme', value: 'Ağır koşul / Büyük kesit' },
              { label: 'Bant Genişliği', value: '34 × 1,10 – 80 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
              { label: 'Uygulama', value: 'Ağır kesim, sert malzeme' },
            ],
            advantages: ['Ağır koşul dayanımı', 'Premium kaplama', 'Büyük kesit gücü'],
          },
          {
            id: 'taurus-premium', name: 'TAURUS® PREMIUM', level: 4, tagline: 'Büyük kesit premium',
            desc: 'Büyük kesit ve çoklu operasyonlarda sert kaplamayla maksimum bıçak ömrü.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli' },
              { label: 'Malzeme', value: 'Büyük kesit / Çoklu kesim' },
              { label: 'Bant Genişliği', value: '34 × 1,10 – 80 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
            ],
            advantages: ['Büyük kesit premium', 'Çoklu operasyon', 'Maximum ömür'],
          },
          {
            id: 'futura-premium-va', name: 'FUTURA® PREMIUM VA', level: 4, tagline: 'Titreşimsiz premium profil',
            desc: 'Değişken adımlı diş + premium sert kaplama. Profil ve boru kesiminde en üst düzey performans.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Karbür, Değişken adımlı (VA)' },
              { label: 'Malzeme', value: 'İçi boş profil / Boru' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 67 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
            ],
            advantages: ['VA + Premium kaplama', 'Profil kesimde zirve', 'Minimum vibrasyon'],
          },
          {
            id: 'arion-fg', name: 'ARION® FG', level: 3, tagline: 'İnce cidarlı hassas kesim',
            desc: 'İnce cidarlı profil ve boru kesimlerinde hassas yüzey kalitesi için özel karbür uçlu model.',
            specs: [
              { label: 'Ürün Seviyesi', value: '3' },
              { label: 'Diş Tipi', value: 'Karbür İnce pençe dişli (FG)' },
              { label: 'Malzeme', value: 'İnce cidarlı profil' },
              { label: 'Bant Genişliği', value: '13 × 0,65 – 54 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert malzeme kaplama' },
              { label: 'Uygulama', value: 'İnce et kalınlığı, hassas kesim' },
            ],
            advantages: ['İnce et profil için özel', 'Hassas yüzey' , 'Minimum çapak'],
          },
          {
            id: 'futura-premium-sn', name: 'FUTURA® PREMIUM SN', level: 4, tagline: 'Paslanmaz premium',
            desc: 'Paslanmaz çelik ve özel alaşımlar için sert kaplamalı premium karbür versiyon.',
            specs: [
              { label: 'Ürün Seviyesi', value: '4 — Premium' },
              { label: 'Diş Tipi', value: 'Karbür Pençe dişli (SN)' },
              { label: 'Malzeme', value: 'Paslanmaz / Dubleks / Süper alaşım' },
              { label: 'Bant Genişliği', value: '27 × 0,90 – 67 × 1,60 mm' },
              { label: 'Kaplama', value: 'Sert madde kaplama' },
              { label: 'Karbür Grade', value: 'SN — Paslanmaz Özel + Kaplama' },
            ],
            advantages: ['Paslanmaz premium', 'SN grade + kaplama', 'Mükemmel yüzey kalitesi'],
          },
        ]
      },
    ]
  },

  'elmas-cbn': {
    title: 'Elmas ve CBN Şerit Testereler',
    subtitle: 'Cam, seramik ve 55+ HRC çeliklerde sıfır fire ile çapaksız hassas kesim.',
    seoContent: `
      <h2>Elmas ve CBN Kaplı Şerit Testere Teknolojisi</h2>
      <p>Şerit testere dünyasının en sert kesicileri olan Elmas ve CBN (Kübik Bor Nitrür) kaplı bıçaklar, geleneksel dişli testerelerin kesmek yerine sadece parçalandığı aşırı sert malzemeler için tasarlanmıştır. Bu bıçaklar "diş" yerine, şerit üzerine elektroliz veya sinterleme yöntemiyle kaplanmış aşındırıcı partikülleri kullanır.</p>
      
      <h3>Elmas (Diagrit) mı, CBN (Cubogrit) mi?</h3>
      <ul>
        <li><strong>Elmas (DIAGRIT®):</strong> Cam, seramik, mermer, grafit, karbon fiber ve silikon gibi metalik olmayan aşırı sert veya aşındırıcı malzemelerin kesiminde rakipsizdir.</li>
        <li><strong>CBN (CUBOGRIT®):</strong> 55 HRC ve üzeri sertlikteki çelikler, yüksek hız çelikleri (HSS) ve sertleştirilmiş rulman çelikleri gibi metalik malzemelerde kullanılır. Karbonlu çeliklerde elmasın karbonla tepkimeye girmesi nedeniyle CBN tek çözümdür.</li>
      </ul>
      
      <h3>Teknik Üstünlükler</h3>
      <p>Bu bıçaklar sayesinde en hassas malzemelerde bile çatlama veya çapaklanma olmadan, "sıfır fire" mantığıyla kesim yapmanıza olanak tanır. Özellikle yarı iletken endüstrisi, havacılık kompozitleri ve hassas kalıpçılık operasyonlarında vazgeçilmezdir.</p>
      <p>NetTest Testere uzmanlığı ile malzemeniz için en uygun grit (partikül) boyutunu ve bant genişliğini birlikte belirliyoruz.</p>
    `,
    groups: [
      {
        label: 'Elmas Kaplı — DIAGRIT®',
        items: [
          { id: 'diagrit-k', name: 'DIAGRIT® K', level: 3, tagline: 'Cam elyaf ve seramik kesimi', desc: 'Karbon fiber, cam elyaf ve seramik kesiminde hassas elmas kaplama. K — Kopmaz diş formuyla zorlu yüzeyler.', specs: [{ label: 'Kaplama', value: 'Elmas (Diamond)' }, { label: 'Diş Formu', value: 'K — Kopmaz tip' }, { label: 'Bant Genişliği', value: '20 × 0,90 – 54 × 1,60 mm' }, { label: 'Uygulama', value: 'CFRP, cam elyaf, seramik' }], advantages: ['Cam elyaf kesimi', 'Seramik optimize', 'Minimum çapak'] },
          { id: 'diagrit-k-va', name: 'DIAGRIT® K VA', level: 3, tagline: 'Değişken adımlı elmas', desc: 'Değişken adımlı elmas kaplı bıçak; titreşim azaltıcı K tipi diş geometrisi.', specs: [{ label: 'Kaplama', value: 'Elmas (Diamond)' }, { label: 'Diş Formu', value: 'K VA — Değişken adımlı' }, { label: 'Bant Genişliği', value: '20 × 0,90 – 54 × 1,60 mm' }, { label: 'Uygulama', value: 'CFRP, karma profil' }], advantages: ['Titreşim azaltma', 'VA teknoloji', 'Karma malzeme'] },
          { id: 'diagrit-s', name: 'DIAGRIT® S', level: 3, tagline: 'Silikon bazlı malzeme', desc: 'Silikon içerikli malzemelerde yüksek hassasiyetli kesim için özel S tipi diş geometrisi.', specs: [{ label: 'Kaplama', value: 'Elmas (Diamond)' }, { label: 'Diş Formu', value: 'S — Silikon optimizeli' }, { label: 'Bant Genişliği', value: '20 × 0,90 – 54 × 1,60 mm' }, { label: 'Uygulama', value: 'Silisyum karbür, SiC' }], advantages: ['Silikon bazlı optimize', 'Hassas yüzey', 'Özel S geometrisi'] },
          { id: 'diagrit-s-va', name: 'DIAGRIT® S VA', level: 3, tagline: 'Silikon + değişken adım', desc: 'Silikon alaşımlarda titreşim azaltıcı değişken adımlı diş formuyla üstün performans.', specs: [{ label: 'Kaplama', value: 'Elmas (Diamond)' }, { label: 'Diş Formu', value: 'S VA — Değişken adımlı' }, { label: 'Bant Genişliği', value: '20 × 0,90 – 54 × 1,60 mm' }, { label: 'Uygulama', value: 'Silisyum, SiC, karma' }], advantages: ['S + VA kombinasyonu', 'Düşük vibrasyon', 'Silikon optimize'] },
          { id: 'diagrit-u', name: 'DIAGRIT® U', level: 3, tagline: 'Universal elmas kaplı', desc: 'Çok yönlü non-metalik sert malzeme kesimi için universal elmas kaplı testere.', specs: [{ label: 'Kaplama', value: 'Elmas (Diamond)' }, { label: 'Diş Formu', value: 'U — Universal' }, { label: 'Bant Genişliği', value: '20 × 0,90 – 54 × 1,60 mm' }, { label: 'Uygulama', value: 'Genel non-metalik sert malzeme' }], advantages: ['Çok yönlü', 'Geniş malzeme yelpazesi', 'Universal diş geometrisi'] },
          { id: 'diagrit-u-va', name: 'DIAGRIT® U VA', level: 4, tagline: 'Universal premium elmas', desc: 'Universal elmas kaplama + değişken adım teknolojisinin birleşimi. Geniş malzeme yelpazesinde premium performans.', specs: [{ label: 'Kaplama', value: 'Elmas (Diamond)' }, { label: 'Diş Formu', value: 'U VA — Universal + Değişken' }, { label: 'Uygulama', value: 'Non-metalik, karma malzeme' }], advantages: ['U + VA premium', 'Maximum verimlilik', 'Geniş uygulama'] },
        ]
      },
      {
        label: 'CBN Kaplı — CUBOGRIT®',
        items: [
          { id: 'cubogrit-k', name: 'CUBOGRIT® K', level: 4, tagline: 'Sertleştirilmiş çelik CBN', desc: 'Sertleştirilmiş çelik ve HSS malzemelerde CBN (Kübik Bor Nitrür) kaplama ile üstün kesim.', specs: [{ label: 'Kaplama', value: 'CBN (Cubic Boron Nitride)' }, { label: 'Diş Formu', value: 'K — Kopmaz tip' }, { label: 'Sertlik uyumu', value: '55+ HRC' }, { label: 'Uygulama', value: 'HSS, sertleştirilmiş çelik' }], advantages: ['55+ HRC malzeme kesimi', 'CBN kaplama dayanımı', 'HSS optimize'] },
          { id: 'cubogrit-s', name: 'CUBOGRIT® S', level: 4, tagline: 'Yüksek hız çeliği CBN', desc: 'Yüksek hız çeliği ve rulman çeliklerinde CBN kaplama teknolojisi.', specs: [{ label: 'Kaplama', value: 'CBN (Cubic Boron Nitride)' }, { label: 'Diş Formu', value: 'S — Özel geometri' }, { label: 'Uygulama', value: 'HSS, rulman çelikleri' }], advantages: ['HSS kesimi', 'Rulman çeliği optimize', 'CBN dayanımı'] },
          { id: 'cubogrit-u', name: 'CUBOGRIT® U', level: 4, tagline: 'Universal CBN kaplı', desc: 'Universal CBN kaplı; sert metalik malzemelerde çok yönlü kesim.', specs: [{ label: 'Kaplama', value: 'CBN (Cubic Boron Nitride)' }, { label: 'Diş Formu', value: 'U — Universal' }, { label: 'Uygulama', value: 'Sertleştirilmiş çelik genel' }], advantages: ['Çok yönlü CBN', 'Geniş uygulama', 'Sert metalik malzeme'] },
        ]
      },
      {
        label: 'Karbür Kaplı — TCGRIT®',
        items: [
          { id: 'tcgrit-k', name: 'TCGRIT® K', level: 3, tagline: 'Karbür kaplı non-metalik', desc: 'Takviyeli plastik, grafit ve karbon gibi non-metalik sert malzemelerde karbür kaplama ile uzun ömür.', specs: [{ label: 'Kaplama', value: 'Karbür (TC)' }, { label: 'Diş Formu', value: 'K — Kopmaz tip' }, { label: 'Uygulama', value: 'Takviyeli plastik, grafit, karbon' }], advantages: ['Non-metalik sert malzeme', 'Karbür kaplama', 'Uzun ömür'] },
          { id: 'tcgrit-u', name: 'TCGRIT® U', level: 3, tagline: 'Universal karbür kaplı', desc: 'Non-metalik karma malzemelerde çok yönlü kullanım için karbür kaplı universal testere.', specs: [{ label: 'Kaplama', value: 'Karbür (TC)' }, { label: 'Diş Formu', value: 'U — Universal' }, { label: 'Uygulama', value: 'Non-metalik karma malzeme' }], advantages: ['Universal kaplama', 'Karma malzeme', 'Çok yönlü'] },
        ]
      },
    ]
  },

  karbon: {
    title: 'Karbon Şerit Testereler',
    subtitle: 'Ahşap, plastik ve hafif metaller için esnek ve kırılmaya karşı dirençli yapı.',
    groups: [
      {
        label: 'Starrett Karbon Serisi',
        items: [
          {
            id: 'duratec-sfb', name: 'DURATEC™ SFB', level: 1, tagline: 'Sünek ve Esnek Çelik Bant',
            desc: 'Özel yüksek karbonlu çelik sırt malzemesi içeren Duratec SFB, ahşap ve hafif metal kesimlerinde yüksek kırılma direnci gösterir.',
            specs: [
              { label: 'Ürün Seviyesi', value: '1 — Karbon' },
              { label: 'Uygulama', value: 'Ahşap, plastik, hafif metal' },
              { label: 'Kesme Malzemesi', value: 'Yüksek Karbon Çeliği' },
            ],
            advantages: ['Esnek şerit yapısı', 'Aşınmaya dayanıklı', 'Ekstra kırılma direnci'],
          },
          {
            id: 'duratec-fc', name: 'DURATEC™ FC', level: 1, tagline: 'Odun ve Ahşap Kesimi',
            desc: 'Düşük devirli atölye testerelerinde ve mobilya/ahşap atölyelerinde genel işler için optimal diş açısı.',
            specs: [
              { label: 'Ürün Seviyesi', value: '1 — Karbon' },
              { label: 'Uygulama', value: 'Ahşap, MDF, Kontrplak' },
            ],
            advantages: ['Pürüzsüz ahşap kesimi', 'Sertleştirilmiş uçlar'],
          },
          {
            id: 'serit-bicaklari', name: 'ŞERİT BIÇAKLARI', level: 1, tagline: 'Dişsiz Kesim Çözümü',
            desc: 'Kâğıt, sünger, kauçuk, kumaş, deri ve yumuşak plastiklerin dişsiz (slice) olarak temiz ve minimum fireyle kesilmesi için özel üretilmiş bıçaklar.',
            specs: [
              { label: 'Ürün Seviyesi', value: '1 — Karbon' },
              { label: 'Uygulama', value: 'Sünger, Deri, Kumaş, Lastik' },
              { label: 'Kenar Tipi', value: 'Dişsiz / Bıçak' },
            ],
            advantages: ['Sıfır fire kesim', 'Temiz yüzey', 'Tozsuz kesim'],
          },
        ]
      }
    ]
  },

  'daire-testere': {
    title: 'Daire Testereler',
    subtitle: 'Boru ve profil kesiminde yüksek hassasiyet ve titreşimsiz yüzey kalitesi.',
    groups: []
  },
};
